import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  Header,
  HeaderFixed,
  WrpperAuthorizedContainer,
  Wrapper,
  TransactionCard,
  MainPayupCard,
  TransactionCardEmpty,
  NoteText,
} from '../../../../components/base/core';
import { Box } from '@mui/material';

import {
  useGetTransactionDetailsQuery,
  useGetTreasuryTransactionsQuery,
} from 'src/services/account/accountServiceApi';

import { EmptyStates } from 'src/shared/utilities/images';
import { ManualLoader } from 'src/components/base/core/OtherUtilities/Loader/ManualLoader';
import { brand } from 'src/shared/branding/brand';

export const FinanceAccountMainContainer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, isLoading } = useGetTreasuryTransactionsQuery(null);
  const {
    data: tdData,
    isSuccess: isSuccessTD,
    isLoading: isLoadingTD,
  } = useGetTransactionDetailsQuery(null);

  return (
    <>
      {isLoading && isLoadingTD && <ManualLoader />}
      <HeaderFixed className="fixed_only_desktop">
        <Header
          isMainMunuVisible
          isSkipButtonHide
          isBackButtonHide
          paddingX={0}
          headerPaddingBottom={0}
          isLogoOnlyForDesktop
        />
      </HeaderFixed>
      <Wrapper isAuthorizedWrapper>
        <WrpperAuthorizedContainer>
          <Box>
            <MainPayupCard
              title={t('finance.mainScreen.cardTitle')}
              tdData={tdData}
              isSuccessTD={isSuccessTD}
              navigate={navigate}
              buttonTexts={{
                moveMoney: t('finance.mainScreen.btnTextMoveMoney'),
                manageCard: t('finance.mainScreen.btnTextmanageCard'),
              }}
              cardTexts={{
                balanceSummaryTitle: t('finance.mainScreen.balanceSummaryTitle'),
                cardShowNumberText: t('finance.mainScreen.cardShowNumberText'),
              }}
            />
          </Box>
          <Box>
            {data && data.length > 0 && (
              <TransactionCard
                data={data}
                title={t('finance.mainScreen.recentTransaction.title')}
                onClick={() => navigate('/finance/account/list')}
                clickOnCard={() => navigate('/finance/account/list')}
                viewAllLinkText={t('finance.mainScreen.recentTransaction.viewAllLinkText')}
                isRecentTransaction={true}
              />
            )}

            {data && data.length === 0 && (
              <TransactionCardEmpty
                title={t('finance.mainScreen.recentTransaction.title')}
                imagePath={EmptyStates.aprroved}
                emptyStateTitle={t('finance.mainScreen.recentTransaction.emptyStateTitle')}
                emptyStateContent={t('finance.mainScreen.recentTransaction.emptyStateContent')}
              />
            )}
            <NoteText>
              {t('finance.transaction.details.termsNote')}{' '}
              <a href={`mailto:${brand.supportEmail}`}>our support team</a>
            </NoteText>
          </Box>
          {brand.key === 'payup' && (
            <Box
              sx={{
                textAlign: 'center',
                margin: '24px 16px 8px',
                padding: '12px 16px',
                borderRadius: '8px',
                backgroundColor: '#F7F8FF',
                color: '#5B5FED',
                fontSize: '13px',
                lineHeight: 1.5,
                fontWeight: 500,
              }}
            >
              Coming soon — PayUp will be BillRoute Pay. Same app, new name.
            </Box>
          )}
        </WrpperAuthorizedContainer>
      </Wrapper>
    </>
  );
};
